// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .image-block {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n  }\n", ""]);
// Exports
module.exports = exports;
